export default __webpack_public_path__ + "static/media/nesto-group-logo2.2cf8b69a.svg";